import * as React from 'react';
import { styled } from 'styled-components';
import { useLocation } from 'react-router-dom';
import AvatarIcon from '../../common/svgIcons/AvatarIcon';
import { useNavigateWithAppName } from '../../common/NavigateWithAppName';
import { useProfileFileString } from '../../../core/api/files';
import { profileIcon } from './guidedTour/stepToLocationMap';
import { userSocialProfileOverviewPageUrl } from '../../../core/constants';
import { whiteColour } from '../../cssConstants';

const UserSocialProfileIcon = () => {
	const location = useLocation();
	const navigate = useNavigateWithAppName();
	const profileFileString = useProfileFileString();

	const handleUserProfileIconClick = () => {
		navigate(userSocialProfileOverviewPageUrl, { state: { previousPageUrl: location.pathname } });
	};

	return (
		<StyledUserProfileIcon onClick={handleUserProfileIconClick} data-joyride={profileIcon}>
			{profileFileString !== undefined &&
				(profileFileString ? (
					<StyledImage src={`data:image/jpeg;base64,${profileFileString}`} alt="user profile icon" />
				) : (
					<DefaultAvatar size={30} />
				))}
		</StyledUserProfileIcon>
	);
};

export default UserSocialProfileIcon;

const StyledUserProfileIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
`;

const StyledImage = styled.img`
	width: 30px;
	height: 30px;
	border-radius: 50%;
	border: 1px solid ${whiteColour};
`;

const DefaultAvatar = styled(AvatarIcon)`
	border: 1px solid ${whiteColour};
	border-radius: 50%;
`;
